import React, { useState, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { convertToRaw } from 'draft-js'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import MUIRichTextEditor from 'mui-rte'
import buildValidUrlFromContentState from 'lib/rte-utils/build-valid-url'
import RecommendedDetailsDialog, {
  offeringRecommendationsConfig,
} from 'components/recommended-event-details-dialog'

const useStyles = makeStyles(theme => ({
  editorRoot: {
    minHeight: '400px',
    border: '1px solid #E0E0E0',
    borderRadius: '4px',
    padding: '0 16px',
    marginTop: '24px',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
  },
}))

const EventDescription = () => {
  const { register, setValue, getValues } = useFormContext()
  const [isOpen, setIsOpen] = useState(false)
  const classes = useStyles()

  useEffect(() => {
    register('description')
  }, [register])

  const defaultValue = getValues('description')

  return (
    <>
      <div className={classes.editorRoot}>
        <MUIRichTextEditor
          label="Enter your offering description..."
          controls={['title', 'bold', 'italic', 'bulletList', 'link']}
          style={{ minHeight: '500px' }}
          defaultValue={defaultValue}
          onChange={value => {
            const content = JSON.stringify(
              buildValidUrlFromContentState(
                convertToRaw(value.getCurrentContent()),
              ),
            )
            setValue('description', content)
          }}
        />
      </div>
      <Button onClick={() => setIsOpen(true)}>
        Recommended offering details
      </Button>
      <RecommendedDetailsDialog
        title="Recommended offering details"
        recommendations={offeringRecommendationsConfig}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  )
}

export default EventDescription
